/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForLogstash extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForLogstash");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForLogstash.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForLogstash>): ServiceAccountNativeDetailsForLogstash {
        let obj = Object.assign(new ServiceAccountNativeDetailsForLogstash(), model);
        ServiceAccountNativeDetailsForLogstash.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForLogstash>): ServiceAccountNativeDetailsForLogstash {
        if (!model) return null;
        return ServiceAccountNativeDetailsForLogstash.newInstance(<ServiceAccountNativeDetailsForLogstash> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForLogstash) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForLogstash.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForLogstash): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForLogstash.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
